/* eslint-disable no-undef */
// ^ This tells ESLint to stop worrying about the Webpack global in this file

export const IS_FEDERATE_MODULE = typeof __webpack_public_path__ !== 'undefined' && __webpack_public_path__.startsWith('http');

export const getBaseUrl = (path) => {
  let base = "";

  try {
    // 1. Check if the Webpack global exists and isn't just a relative slash
    if (IS_FEDERATE_MODULE) {
      // 2. Use the URL constructor to extract the origin
      base = new URL(__webpack_public_path__).origin;
    }
  } catch (e) {
    console.warn("Could not parse __webpack_public_path__, falling back to relative.");
  }

  return `${base}${path}`;
};